import React from 'react';
import MomentsEmailClient from './MomentsEmailClient';
import DeleteAccount from './DeleteAccount';
import AuthAccounts from './AuthAccounts/AuthAccounts';
import PreferredEmail from './PreferredEmail';
import DataExport from './DataExport';
import Sidebar from './Sidebar';
import MergingSettings from './Merging';
import Reminders from './Reminders';

export default function GeneralSettingsPanel() {
  return (
    <>
      <PreferredEmail />
      <AuthAccounts />
      <Sidebar />
      <Reminders />
      <MomentsEmailClient />
      <MergingSettings />
      <DataExport />
      <DeleteAccount />
    </>
  );
}
